import * as React from "react";
import { Loading, ErrorBoundary } from "nsitools-react";
import styled from "styled-components";
import { PropsWithChildren } from "react";

const Container = styled.div<{ iscentered: number; fullheight: number }>`
  display: flex;
  justify-content: ${({ iscentered }) => (iscentered ? "center" : null)};
  align-items: ${({ iscentered }) => (iscentered ? "center" : null)};
  width: 100%;
  height: ${({ fullheight }) => (fullheight ? "100vh" : "100%")};
  flex-direction: column;
`;

export interface IPageContainerProps extends PropsWithChildren {
  isLoading?: boolean;
  isCentered?: boolean;
  isFullHeight?: boolean;
}

export const PageContainer: React.FunctionComponent<IPageContainerProps> = ({
  children,
  isLoading = false,
  isCentered = false,
  isFullHeight = false,
}) => {
  return (
    <Container iscentered={isCentered ? 1 : 0} fullheight={isFullHeight ? 1 : 0}>
      <ErrorBoundary>
        <Loading isLoading={isLoading}>{children}</Loading>
      </ErrorBoundary>
    </Container>
  );
};
